package com.iregained.eventapp.components.sections.event_booking.sections

import androidx.compose.runtime.Composable
import com.iregained.eventapp.components.models.EventDetailsData
import com.iregained.eventapp.theme.toSitePalette
import com.iregained.eventapp.utils.LocalBreakpoint
import com.iregained.eventapp.utils.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun EventHeroSection(eventData: EventDetailsData = EventDetailsData()) {
    val breakpoint = LocalBreakpoint.current
    val isDesktop = breakpoint >= Res.Breakpoints.LG
    val palette = ColorMode.current.toSitePalette()

    // Dynamically calculate the date range from the operating schedule
    val activeDays = eventData.operatingSchedule.filter { !it.isClosed }
    val dateRangeDisplay = if (activeDays.isNotEmpty()) {
        val firstDate = activeDays.first().date
        val lastDate = activeDays.last().date
        if (firstDate == lastDate) firstDate else "$firstDate to $lastDate"
    } else {
        "Dates TBA"
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.brandPrimary)
            .padding(topBottom = if (isDesktop) 60.px else 30.px, leftRight = 5.percent),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(if (isDesktop) 80.percent else 100.percent),
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "${eventData.city.uppercase()} • $dateRangeDisplay",
                modifier = Modifier
                    .fontSize(14.px)
                    .fontWeight(FontWeight.Bold)
                    .color(palette.brand.primarySoft)
                    .margin(bottom = 8.px)
            )
            SpanText(
                text = eventData.title,
                modifier = Modifier
                    .fontSize(if (isDesktop) 36.px else 24.px)
                    .fontWeight(FontWeight.Bold)
                    .color(org.jetbrains.compose.web.css.Color.white)
                    .margin(bottom = 12.px)
            )
            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    text = "📍 ${eventData.venueName} (${eventData.timezone})",
                    modifier = Modifier
                        .fontSize(16.px)
                        .color(org.jetbrains.compose.web.css.Color.white)
                )
            }
        }
    }
}